import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { Project } from '@/features/projects/types';
import { ConnectionInfraFormNew, ConnectionInfraSubmitPayload } from './connection-infrastructure-form-new';

export type ConnectionInfraDrawerProps = {
  readonly formId: string;
  readonly project: Project;
  readonly onSubmit: (item: any, description?: string) => void;
  readonly onClose: () => void;
  readonly isOpen: boolean;
};

export function ConnectionInfraDrawerNew({formId, project, onSubmit, onClose, isOpen }: ConnectionInfraDrawerProps) {
  const { t } = useTranslation(['projects']);

  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Connection Infrastructures')} open={isOpen} onClose={onClose} footer={footer}>
      <ConnectionInfraFormNew
        id={formId}
        project={project}
        onSubmit={(data: ConnectionInfraSubmitPayload) => {
          onSubmit(data, t('Connection Infrastructures section has been updated'));
        }}
      />
    </Drawer>
  );
}
